import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { Http, Response } from '@angular/http';
import { REDEEM_INVESTOR } from '../../models/Redeem';
import { ISSUANCE_INVESTOR } from '../../models/issuance';
import { VW_SERIES_SA } from '../../models/seriessa';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HeaderService } from '../../header.service';
import { ProfileService } from '../../profile.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import * as Globals from '../../globals';
import { PaginationComponent } from '../../pagination/pagination.component';
import { ExcelService } from 'app/excel.service';
const url = Globals.serviceUrl;

@Component({
  selector: 'app-custom-redemption',
  templateUrl: './custom-redemption.component.html',
  styleUrls: ['./custom-redemption.component.css']
})
export class CustomRedemptionComponent implements OnInit {
  @ViewChild(PaginationComponent) child: PaginationComponent;
  idtyNo: string;
  invId: number;
  //redeems: REDEEM_INVESTOR[];
  redeems:any;
  //issuances: ISSUANCE_INVESTOR[];
  issuances:any;
  totBids: number = 0;
  totAlts: number = 0;
  cds: any[];
  tab: number=1;
  param: any;
  search: string = '';
  loading: boolean;
  seriesId: number;
  totRedeem: number = 0;
  paramSeries: any = { OPEN: false };
  urlFile = Globals.archiveUrl + 'bids?code=';
  series: any[];
  p: number = 1;
  userProfile: any;
  authMenu: any;
  colSort: string[] = ['BID_DATE'];
  reverse: boolean = true;
  pageSize: number = 10;
  rawdata: any[];
  //sort: string[] = ['BIDDATE'];
  col: number = 5;
  statusId: number = 0;
  rptType: number = 1;
  ssId: number = 0;
  seriessa: VW_SERIES_SA[];
  all: boolean;
  pagedList: any;
  pageNumber: number = 1;

  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private route: ActivatedRoute, private router: Router,private excelService:ExcelService) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/ritelonline/monitoring/redemption/0') {
          this.tab = 1;
          this.router.navigate(['/ritelonline/monitoring/redemption/1']);
        }
      };
    });
  }
  ngOnInit() {

    let id = +this.route.snapshot.params['id'];
    if (id == 0) {
      this.router.navigate(['/ritelonline/monitoring/redemption/1']);
    }
    
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.getSeries();
      this.authMenu = Globals.getAuthMenu(206, this.userProfile);
    }
  }

  sort(val: number) {
    this.col = val;
    this.reverse = !this.reverse;
    switch (val) {
      case 1:
        this.colSort = ['IDTY_NO'];
        break;
      case 2:
        this.colSort = ['INV_NAME'];
        break;
      case 3:
        this.colSort = ['REDEMP_ID'];
        break;
      case 4:
        this.colSort = ['ALT_AMT'];
        break;
      case 5:
        this.colSort = ['BID_DATE'];
        break;
      case 6:
        this.colSort = ['REDEEM_AMT'];
        break;
      case 7:
        this.colSort = ['SELLING_AGENT'];
        break;
      default:
        break;
    }
  }

  seriesChanged(ev: any) {
    this.seriesId = ev.target.value;
    this.getRedeems(1);
    for (var i = 0; i < this.series.length; i++) {
      if (this.seriesId == this.series[i].SERIES_ID) {
        this.paramSeries = this.series[i];
        break;
      }
    }
    /*if (!this.paramSeries.OPEN) {
      this.toastr.warning("Masa penawaran telah berakhir");
    }*/
  }

  ssIdChanged(ev: any) {
    this.ssId = ev.target.value;
    //this.getIssues(1);
    this.getRedeems(1);
  }

  getIssues(pageNumber: number) {
    this.loading = true;
    this.http.get(url + 'ritel/redeemsonline?seriesId=' + this.seriesId + '&search=' + this.search + '&ssId=' + this.ssId + '&statusId=' + this.statusId + '&pageNumber=' + pageNumber + '&pageSize=' + this.pageSize + '&sort=' + this.sort + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.issuances = res.json();
        this.totBids = 0;
        this.totAlts = 0;
        for (var i = 0; i < this.issuances.length; i++) {
          this.totBids += this.issuances[i].BID_AMT;
          this.totAlts += this.issuances[i].ALT_AMT;
        }
        /*if (!this.paramSeries.OPEN) {
          this.toastr.warning('Masa penawaran telah berakhir');
        }*/
        //this.getCds(28);
        this.getSeriesSa();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getRedeems(pageNumber: number) {
    this.loading = true;
    this.all = true;
    //this.pagedList = {};
    this.redeems = [];
    this.http.get(url + 'ritel/redeemsonline?seriesId=' + this.seriesId + '&search=' + this.search + '&ssId=' + this.ssId + '&statusId=' + this.statusId + '&pageNumber=' + pageNumber + '&pageSize=' + this.pageSize + '&sort=' + this.sort + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        //this.redeems = res.json();
        this.pagedList = res.json();
        this.redeems = this.pagedList.Model.Records;
        this.pageNumber = pageNumber;
        //this.totRedeem = 0;
        this.child.getPagination(pageNumber, this.pagedList.Model);
        this.totBids = this.pagedList.Model.TotalNominal;

        // for (var i = 0; i < this.redeems.length; i++) {
        //   this.totRedeem += this.redeems[i].REDEEM_AMT;
        // }

        /*if (!this.paramSeries.OPEN) {
          this.toastr.warning('Masa penawaran telah berakhir');
        }*/
        this.getSeriesSa();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getSeries() {
    this.loading = true;
    this.http.get(url + 'ritel/redeemactive?cdOnline=2&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.series = res.json();
        if (this.series.length > 0) {
          this.seriesId = this.series[0].SERIES_ID;
          for (var i = 0; i < this.series.length; i++) {
            if (this.seriesId == this.series[i].SERIES_ID) {
              this.paramSeries = this.series[i];
              break;
            }
          }
          this.getRedeems(1);
          //this.getIssues(1);
        } else if (this.series.length == 0) {
          //this.toastr.warning('Masa penawaran telah berakhir');
          this.loading = false;
        } else {
          this.loading = false;
        }
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  generateReport(format: string) {

    this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '",format:"' + format + '",rpttype:' + this.rptType + '}' };
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'Rpt901?id=' + this.param.TICKET_ID, '_blank');
      }, err => {
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }

  downloadCSV() {
    this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '"}' };
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'ExportCSVRedeemOnline?id=' + this.param.TICKET_ID, '_blank');
      }, err => {
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }

  getSeriesSa() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/seriessa?seriesId=' + this.seriesId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.seriessa = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getCds(cgNo: number) {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/cds?cgno=' + cgNo + '&t' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.cds = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  pageChange(pageNumber: number) {
    if (this.all) {
        this.getRedeems(pageNumber);
    }

  }

  getRawdata() {
    this.loading = true;
    this.http.get(url + 'ritel/rawdata?seriesId=' + this.seriesId  + '&aucType=2&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.rawdata = res.json();
        this.excelService.exportAsExcelFile(this.rawdata, this.paramSeries.SERIES_NAME);
        //onsole.log(this.series);
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }



}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/ritel-online/custom-redemption/custom-redemption.component.ts